import React from "react";
import { Button } from "./../../common/Button/Button";
import { useEffect, useState } from "react";
import api from "../../utils/api";
import Spinner from "../../common/Spinner/Spinner";
import { toast } from "react-toastify";
import DateRange from "../../components/ServiceRequests/Facilitator/DateRange";
import { set } from "lodash";
import Select from "react-select";
import { WEBAPP_URL } from "../../utils/constants";
import Checkbox from "../../common/Checkbox/Checkbox";
import {Input} from "../../common/Input/Input";
// import {WEBAPP_URL}  from "../../utils/constants";

export default function ReportContainer(props) {
	useEffect(() => {
		//make an api call to the server
		//for any initialisation data.
	}, []);
	const [isLoading, setLoading] = useState(false);
	const [isUnassigned, setIsUnassigned] = useState(false);

	const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

	/**Audit log entry */
	const [auditLogEntryDateFrom, setAuditLogEntryDateFrom] = useState();
	const [auditLogEntryDateTo, setAuditLogEntryDateTo] = useState();
	const onAuditLofEntryDateChange = (key, date) => {
		if (key === "fromDate") {
			setAuditLogEntryDateFrom(date);
		} else if (key === "toDate") {
			setAuditLogEntryDateTo(date);
		}
	};

	/** HH KRA report Activity Log */
	const [
		completionStatusOptionsHHKRA,
		setCompletionStatusOptionsHHKRA,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedCompletionStatusHHKRA,
		setSelectedCompletionStatusHHKRA,
	] = useState({
		value: "no",
		label: "No",
	});

	const [srAssginedDateFrom, setSrAssignedDateFrom] = useState();
	const [srAssignedDateTo, setSrAssignedDateTo] = useState();
	const onSrAssignedDateChange = (key, date) => {
		if (key === "fromDate") {
			setSrAssignedDateFrom(date);
		} else if (key === "toDate") {
			setSrAssignedDateTo(date);
		}
	};

	/** Ticket-level Activity Log */

	const [logEntryDateFrom, setLogEntryDateFrom] = useState();
	const [logEntryDateTo, setLogEntryDateTo] = useState();
	const onLogEntryDateChange = (key, date) => {
		if (key === "fromDate") {
			setLogEntryDateFrom(date);
		} else if (key === "toDate") {
			setLogEntryDateTo(date);
		}
	};
	/**Service Request to Fullfilment */
	const [srRequestedDateFrom, setSrRequestedDateFrom] = useState();
	const [srRequestedDateTo, setSrRequestedDateTo] = useState();
	const onSrRequestedDateChange = (key, date) => {
		if (key === "fromDate") {
			setSrRequestedDateFrom(date);
		} else if (key === "toDate") {
			setSrRequestedDateTo(date);
		}
	};

	/**
	 * All Services Report
	 */
	const [
		allServicesReportProgressionDateFrom,
		setAllServicesReportProgressionDateFrom,
	] = useState();
	const [
		allServicesReportProgressionDateTo,
		setAllServicesReportProgressionDateTo,
	] = useState();
	const onAllServicesReportProgressionDateChange = (key, date) => {
		if (key === "fromDate") {
			setAllServicesReportProgressionDateFrom(date);
		} else if (key === "toDate") {
			setAllServicesReportProgressionDateTo(date);
		}
	};
	/**
	 * Services Action Report
	 *
	 */
	const [
		completionStatusOptionsFollowupActions,
		setCompletionStatusOptionsFollowupActions,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedCompletionStatusFollowupActions,
		setSelectedCompletionStatusFollowupActions,
	] = useState({
		value: "no",
		label: "No",
	});
	const [
		dateRangeOptionsFollowupAction,
		setDateRangeOptionsFollowupActions,
	] = useState([
		{
			value: "dtFollowupOn",
			label: "Followup On",
		},
		{
			value: "dtCreated",
			label: "Logged on",
		},
		{
			value: "dtUpdated",
			label: "Updated on",
		},
	]);

	const ticketLevelActivityFilters = [{
		value: "c_email",
		label: "Customer Email"
	},
	{
		value: "contact_no",
		label: "Contact Number"
	},
	{
		value: "nResourceInstanceId",
		label: "Service Instance ID"
	},
	{
		value: "actor_email",
		label: "Actor Email - IHH/FAC/EHH/ESP/SP"
	}]

	const [
		selectedTicketLevelActivityFilter,
		setSelectedTicketLevelActivityFilter,
	] = useState({});

	const [
		selectedDateRangeFollowupAction,
		setSelectedDateRangeOptions,
	] = useState({
		value: "dtFollowupOn",
		label: "Followup On",
	});
	const [
		servicesActionsReportFollowupDateFrom,
		setServiesActionsReportFollowupDateFrom,
	] = useState();
	const [
		servicesActionsReportFollowupDateTo,
		setServicesActionsReportFollowupDateTo,
	] = useState();
	const onServicesActionsReportFollowupDateChange = (key, date) => {
		if (key === "fromDate") {
			setServiesActionsReportFollowupDateFrom(date);
		} else if (key === "toDate") {
			setServicesActionsReportFollowupDateTo(date);
		}
	};

	const fetchAllServicesReport = () => {
		setLoading(true);
		try {
			api.getAllServicesReport({
				fromDate: allServicesReportProgressionDateFrom,
				toDate: adjustedToDate(allServicesReportProgressionDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					console.log(error.status);
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchFullfillmentReport = () => {
		setLoading(true);
		try {
			api.getFullfillmentReport({
				fromDate: srRequestedDateFrom,
				toDate: adjustedToDate(srRequestedDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};


	const fetchTicketLevelReport = () => {
		setLoading(true);
		try {
			api.getTicketLevelLog({
				fromDate: logEntryDateFrom,
				toDate: adjustedToDate(logEntryDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchUserRoleAccessReport = () => {
		setLoading(true);
		try {
			api.getUserRoleAccessReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchRoleAccessReport = () => {
		setLoading(true);
		try {
			api.getRoleAccessReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchAuditLogReport = () => {
		setLoading(true);
		try {
			api.getAuditLogReport({
				fromDate: auditLogEntryDateFrom,
				toDate: adjustedToDate(auditLogEntryDateTo),
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchServiceCatalogueReport = () => {
		setLoading(true);
		try {
			api.getServiceCatalogueReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchServiceActionReport = () => {
		setLoading(true);
		try {
			api.getServiceActionReport({
				date_range: selectedDateRangeFollowupAction.value,
				fromDate: servicesActionsReportFollowupDateFrom,
				toDate: adjustedToDate(servicesActionsReportFollowupDateTo),
				completion_status:
					selectedCompletionStatusFollowupActions.value,
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const fetchKRAReport = () => {
		setLoading(true);
		try {
			api.getKRAReport({
				fromDate: srAssginedDateFrom,
				toDate: adjustedToDate(srAssignedDateTo),
				completion_status: selectedCompletionStatusHHKRA.value,
				unassigned: isUnassigned
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			console.log("second")
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchImpactMetricReport = () => {
		setLoading(true);
		try {
			api.getImpactMetricReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchImpactMetricTransactionReport = () => {
		setLoading(true);
		try {
			api.getImpactMetricTransactionReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchEngagementReport = () => {
		setLoading(true);
		try {
			api.getEngagementReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchUserFeedbackReport = () => {
		setLoading(true);
		try {
			api.getCustomerFeedbackReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	const fetchCustomerFRTReport = () => {
		setLoading(true);
		try {
			api.getCustomerFRTReport()
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch (error) {
			setLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

	return (
		<>
			{isLoading && <Spinner className="center-screen" />}
			<div className={`${isLoading && "set-opacity"}`}>
				<br></br>
				<h4>Download Reports: </h4>
				<br></br>
				<div>{/* <h5>Admin Report: </h5> */}</div>
				<Button onClick={fetchUserRoleAccessReport}>
					User Role Access Report
				</Button>
				&nbsp;&nbsp;&nbsp;
				<Button onClick={fetchRoleAccessReport}>
					Role Access Report
				</Button>
				&nbsp;&nbsp;&nbsp; 
				<Button onClick={fetchServiceCatalogueReport}>
					Service Catalogue Report
				</Button>
				&nbsp;&nbsp;&nbsp; 
				<Button onClick={fetchImpactMetricReport}>
					Impact Metric Report
				</Button>
				&nbsp;&nbsp;&nbsp; 
				<Button onClick={fetchImpactMetricTransactionReport}>
					Impact Metric Transactions Report
				</Button>
				&nbsp;&nbsp;&nbsp; 
				<Button onClick={fetchEngagementReport}>
					Engagement Report
				</Button>
				<br></br><br></br>
				
				<Button onClick={fetchUserFeedbackReport}>
					Customer Feedback Report
				</Button>&nbsp;&nbsp;&nbsp;	

				<Button onClick={fetchCustomerFRTReport}>
					FRT Report
				</Button>&nbsp;&nbsp;&nbsp;

				<a href={WEBAPP_URL} target="_blank">
					Go to webapp reports
				</a>
				&nbsp;&nbsp;&nbsp;
				{/* <br></br><br></br><h5>Candidates Report: </h5> */}
				<br></br>
				<br></br>
				<br></br>
				<hr></hr>
				<div>
					<b>
						<span>HH KRA Report </span>
					</b>&nbsp;&nbsp;&nbsp;(Sample File Name: HH KRA Report13Oct18-09.xlsx)
					<br></br>
					<div className="row">
						<div className="col-md-6" style={{ display: "inline" }}>
							<DateRange
								hideDropdown
								label={"SR Assigned Date: "}
								fromDate={srAssginedDateFrom}
								toDate={srAssignedDateTo}
								onDateRangeChange={onSrAssignedDateChange}
							></DateRange>
						</div>
						<div className="col-md-3" style={{ marginTop: "15px" }}>
							<Button onClick={fetchKRAReport}>Generate</Button>
						</div>
					</div>
					<div className="row" style={{ marginTop: "15px" }}>
						<div className="col-md-2">
							<span>Completion Status:</span>
						</div>
						<div className="col-md-2">
							<Select
								style={{ width: "100px" }}
								placeholder="Select completion status"
								options={completionStatusOptionsHHKRA}
								onChange={(value) =>
									setSelectedCompletionStatusHHKRA(value)
								}
								value={selectedCompletionStatusHHKRA}
							></Select>
						</div>

						<div className="col-md-2">
							<Checkbox
								chLabelStyle="service-name-filter-checkbox"
								id="unassigned"
								checked={isUnassigned}
								label=" &nbsp;Unassigned Only"
								onChange={() => setIsUnassigned(!isUnassigned)}
							/>
						</div>
					</div>

				</div>
				<hr style={{ marginTop: "0px !important" }}></hr>
				<div>
					<b>
						<span>SPM All Followup Actions </span>
					</b>&nbsp;&nbsp;&nbsp;(Sample File Name: SPM-FU-Actions-13Oct18-10.xlsx)
					<br></br>
					<div className="row">
						<div className="col-md-6" style={{ marginTop: "10px" }}>
							<DateRange
								options={dateRangeOptionsFollowupAction}
								onDateFilterChange={setSelectedDateRangeOptions}
								dateFilter={selectedDateRangeFollowupAction}
								fromDate={servicesActionsReportFollowupDateFrom}
								toDate={servicesActionsReportFollowupDateTo}
								onDateRangeChange={
									onServicesActionsReportFollowupDateChange
								}
							></DateRange>
						</div>

						<div className="col-md-2" style={{ marginTop: "15px" }}>
							<Button onClick={fetchServiceActionReport}>
								Generate
							</Button>
						</div>
					</div>
					<div className="row" style={{ marginTop: "15px" }}>
						<div className="col-md-6">
							<div className="row">
								<div className="col-md-4">
									<span>Completion Status:</span>
								</div>
								<div className="col-md-3">
									<Select
										customStylingClass="status-dropdown-custom-style-report-container"
										placeholder="Select completion status"
										options={
											completionStatusOptionsFollowupActions
										}
										onChange={(value) =>
											setSelectedCompletionStatusFollowupActions(
												value
											)
										}
										value={
											selectedCompletionStatusFollowupActions
										}
									></Select>
								</div>
							</div>
						</div>
					</div>
				</div>
				<hr style={{ margin: "1" }}></hr>
				<div>
					<b>
						<span>All Services in Progression </span>
					</b>&nbsp;&nbsp;&nbsp;(Sample File Name: ServicesInSPM-13Oct18-11.xlsx)
					<br></br>
					<div className="row">
						<div className="col-md-6" style={{ display: "inline" }}>
							<DateRange
								hideDropdown
								label={"Progression Date:"}
								fromDate={allServicesReportProgressionDateFrom}
								toDate={allServicesReportProgressionDateTo}
								onDateRangeChange={
									onAllServicesReportProgressionDateChange
								}
							></DateRange>
						</div>
						<div className="col-md-3" style={{ marginTop: "15px" }}>
							<Button onClick={fetchAllServicesReport}>
								Generate
							</Button>
						</div>
					</div>
				</div>
				<hr style={{ margin: "1" }}></hr>
				<div>
					<b>
						<span>Service Requests to Fullfilment </span>
					</b>&nbsp;&nbsp;&nbsp;(Sample File Name: ReqToFulfillment-13Oct18-12.xlsx)
					<br></br>
					<div className="row">
						<div className="col-md-6" style={{ display: "inline" }}>
							<DateRange
								hideDropdown
								label={"SR Requested Date:"}
								fromDate={srRequestedDateFrom}
								toDate={srRequestedDateTo}
								onDateRangeChange={onSrRequestedDateChange}
							></DateRange>
						</div>
						<div className="col-md-3" style={{ marginTop: "15px" }}>
							<Button onClick={fetchFullfillmentReport}>Generate</Button>
						</div>
					</div>
				</div>
				<hr style={{ margin: "1" }}></hr>
				<div>
					<b>
						<span>Ticket-level Activity Log </span>
					</b>&nbsp;&nbsp;&nbsp;(Sample File Name: TicketLevelLog-13Oct18-12.xlsx)
					<br></br>
					{/* <div className="row">
						<div className="col-md-2">
							<span>Select filter:</span>
						</div>
						<div className="col-md-2">
							<Select
								customStylingClass="status-dropdown-custom-style-report-container"
								placeholder="Select ticket level activity filter"
								options={
									ticketLevelActivityFilters
								}
								onChange={(value) =>
									setSelectedTicketLevelActivityFilter(
										value
									)
								}
								value={
									selectedTicketLevelActivityFilter
								}
							></Select>
						</div>
						<div className="col-md-2">
						<Input
              className="username"
              name="username"
							placeholder="Enter value"
							disabled={Object.keys(selectedTicketLevelActivityFilter).length === 0 ? true : false}
              // onChange={({ target }) => this.props.onInputChange(target)}
            />
						</div>
					</div> */}
					{/* <br /> */}
					<div className="row">
						<div className="col-md-6" style={{ display: "inline" }}>
							<DateRange
								hideDropdown
								label={"Log Entry Date:"}
								fromDate={logEntryDateFrom}
								toDate={logEntryDateTo}
								onDateRangeChange={onLogEntryDateChange}
							></DateRange>
						</div>
						<div className="col-md-3" style={{ marginTop: "15px" }}>
							<Button onClick={fetchTicketLevelReport}>Generate</Button>
						</div>
					</div>
				</div>
				<br />
					<span> <b>Hint</b> - Form and To date interval cannot exceed 3 months </span>
				<hr style={{ margin: "1" }}></hr>
				<div>
					<b>
						<span>Audit Log Report </span>
					</b>&nbsp;&nbsp;&nbsp;(Sample File Name: Audit Log Report.xlsx)
					<br></br>

					<div className="row">
						<div className="col-md-6" style={{ display: "inline" }}>
							<DateRange
								hideDropdown
								label={"Entry Date:"}
								fromDate={auditLogEntryDateFrom}
								toDate={auditLogEntryDateTo}
								onDateRangeChange={onAuditLofEntryDateChange}
							></DateRange>
						</div>
						<div className="col-md-3" style={{ marginTop: "15px" }}>
							<Button onClick={fetchAuditLogReport}>
								Generate
							</Button>
						</div>
					</div>
				</div>
				<hr style={{ margin: "1" }}></hr>
				<br></br>
				<br />
				<br />
			</div>
		</>
	);
}
